import HuaskyIcon from '@src/components/common/HuaskyIcon.vue'
import HuaskyCity from '@src/components/common/HuaskyCity.vue'
import HuaskyCropUpload from '@src/components/common/HuaskyCropUpload.vue'
import HuaskyDatePick from '@src/components/common/HuaskyDatePick.vue'
import HuaskyDataDic from '@src/components/local/HuaskyDataDic.vue'
import HuaskyScope from '@src/components/local/HuaskyScope.vue'
import HuaskyGoodType from '@src/components/local/HuaskyGoodType.vue'
import HuaskyGoodStatus from '@src/components/local/HuaskyGoodStatus.vue'
import HuaskyTag from '@src/components/local/HuaskyTag.vue'
import HuaskyStaffPost from '@src/components/local/HuaskyStaffPost.vue'
import HuaskyTime from '@src/components/local/HuaskyTime.vue'
import HuaskyQuerySetting from '@src/components/local/HuaskyQuerySetting.vue'
import HuaskyOrderSource from '@src/components/local/HuaskyOrderSource.vue'
import HuaskyBindGood from '@src/components/local/HuaskyBindGood.vue'
import HuaskyDicSetting from '@src/components/local/HuaskyDicSetting.vue'
import HuaskyGoodSelect from '@src/components/local/HuaskyGoodSelect.vue'
import HuaskyStoreSelect from '@src/components/local/HuaskyStoreSelect.vue'
import HuaskySelect from '@src/components/local/HuaskySelect.vue'
import HuaskyDicSingle from '@src/components/local/HuaskyDicSingle.vue'
import HuaskyRangeTime from '@src/components/local/HuaskyRangeTime.vue'
import HuaskyLogisticsType from '@src/components/local/HuaskyLogisticsType.vue'
import HuaskyGoodSelect2 from '@src/components/local/HuaskyGoodSelect2.vue'
import HuaskyListNavigate from '@src/components/local/HuaskyListNavigate.vue'
import HuaskyNavigateOption from '@src/components/local/HuaskyNavigateOption.vue'
import HuaskyMarketingScoped from '@src/components/local/HuaskyMarketingScoped.vue'
import HuaskyGoodDownSelect from '@src/components/local/HuaskyGoodDownSelect.vue'
import HuaskyMarketingTag from '@src/components/local/HuaskyMarketingTag.vue'

// 自定义组件定义

export default {
  install: (app: any) => {
    app.component('HuaskyIcon', HuaskyIcon)     // 注册图标
    app.component('HuaskyCity', HuaskyCity)
    app.component('HuaskyCropUpload', HuaskyCropUpload)
    app.component('HuaskyDataDic', HuaskyDataDic)
    app.component('HuaskyScope', HuaskyScope)
    app.component('HuaskyGoodType', HuaskyGoodType)
    app.component('HuaskyGoodStatus', HuaskyGoodStatus)
    app.component('HuaskyTag', HuaskyTag)
    app.component('HuaskyStaffPost', HuaskyStaffPost)
    app.component('HuaskyTime', HuaskyTime)
    app.component('HuaskyQuerySetting', HuaskyQuerySetting)
    app.component('HuaskyOrderSource', HuaskyOrderSource)
    app.component('HuaskyBindGood', HuaskyBindGood)
    app.component('HuaskyDicSetting', HuaskyDicSetting)
    app.component('HuaskyDatePick', HuaskyDatePick)
    app.component('HuaskyGoodSelect', HuaskyGoodSelect)
    app.component('HuaskyStoreSelect', HuaskyStoreSelect)
    app.component('HuaskySelect', HuaskySelect)
    app.component('HuaskyDicSingle', HuaskyDicSingle)
    app.component('HuaskyRangeTime', HuaskyRangeTime)
    app.component('HuaskyLogisticsType', HuaskyLogisticsType)
    app.component('HuaskyGoodSelect2', HuaskyGoodSelect2)
    app.component('HuaskyListNavigate', HuaskyListNavigate)
    app.component('HuaskyNavigateOption', HuaskyNavigateOption)
    app.component('HuaskyMarketingScoped', HuaskyMarketingScoped)
    app.component('HuaskyGoodDownSelect', HuaskyGoodDownSelect)
    app.component('HuaskyMarketingTag', HuaskyMarketingTag)
  }
}
